import cacheKeys from '@debbie/common/dist/cache/keys.js';
import { Site } from '@debbie/common/dist/index.js';
import { availableScopeGroups, availableScopes, } from '@debbie/common/dist/keys/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as keysLib from '@debbie/cortex/dist/api/keys.js';
import { h } from '@debbie/cortex/dist/index.js';
import { selectedCreditorId } from '@debbie/cortex/dist/internal.js';
import { keysEntity, useKeys } from '@debbie/cortex/dist/keys/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Size } from '../design-system.js';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import ExternalLink from './Icons/ExternalLink.js';
import PlusSquare from './Icons/PlusSquare.js';
import X from './Icons/X.js';
import { Button, Checkbox, CopyToClipboard, Input, MetaItem, MetaList, Modal, Panel, PlaceholderLoader, Well, } from './index.js';
import UserPreview from './performed-by/UserPreview.js';
import PowerTable from './PowerTable.js';
import UserType from './UserType.js';
const APIKeys = (props) => {
    const lang = useSelector((s) => s.lang);
    const keysLoadable = useKeys(selectedCreditorId);
    const keys = h.hasData(keysLoadable) ? keysLoadable.data : null;
    const meRole = useRole();
    const tenantId = useTenantId();
    const site = useSelector((s) => s.site);
    const [modalOpen, setModalOpen] = useState(false);
    const [name, setName] = useState('');
    const [scopes, setScopes] = useState([]);
    const [newKey, setNewKey] = useState('');
    const deleteKeyMutation = useMutation((id) => keysLib.del(id, selectedCreditorId), {
        onSuccess: (res, id) => {
            q.invalidate(cacheKeys.write.modify(keysEntity, id));
        },
        onError: (err) => {
            errorNotification(lang, err, 'delete', lang.errorEntities.apiKey);
        },
    });
    const createKeyMutation = useMutation((params) => keysLib.create(params, selectedCreditorId), {
        onSuccess: (res, id) => {
            q.invalidate(cacheKeys.write.create(keysEntity));
            setNewKey(res.key);
            setName('');
            setScopes([]);
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.apiKey);
        },
    });
    return (React.createElement(Panel, { header: React.createElement("span", null,
            lang.navigation.settingsAPI,
            React.createElement(Button, { style: { float: 'right' }, onClick: () => setModalOpen(!modalOpen), size: "mini" },
                lang.apiSettings.newKeyButton,
                ' ',
                React.createElement(PlusSquare, { style: {
                        margin: '0.1em 0 -0.1em',
                    } }))) },
        React.createElement(MetaList, null,
            tenantId && (React.createElement(MetaItem, null,
                React.createElement("label", null, "tenantId"),
                React.createElement(CopyToClipboard, null, tenantId))),
            selectedCreditorId && Site.Client === site && (React.createElement(MetaItem, null,
                React.createElement("label", null, "creditorId"),
                React.createElement(CopyToClipboard, null, selectedCreditorId))),
            React.createElement(DocsLink, { target: "blank", href: site === Site.Client
                    ? 'https://creditor-documentation.debbiecollect.com'
                    : 'https://documentation.debbiecollect.com' },
                lang.apiSettings.documentation,
                React.createElement(ExternalLink, { size: 14 }))),
        React.createElement("h3", null, lang.apiSettings.keys),
        keys ? (keys.length === 0 ? (React.createElement("h3", { style: {
                textAlign: 'center',
                opacity: 0.7,
            } }, lang.apiSettings.noKeysYet)) : (React.createElement(PowerTable, { data: keys, genKey: (key) => key.id, pagination: {
                type: 'none',
                pageSize: keys.length,
            }, values: {
                id: {
                    label: '',
                    toCmp: (id) => id,
                    map: (id) => {
                        return (React.createElement("div", null, deleteKeyMutation.isLoading ? (React.createElement(PlaceholderLoader, { width: "40px" })) : (React.createElement(X, { onClick: () => deleteKeyMutation.mutate(id), style: { cursor: 'pointer' } }))));
                    },
                },
                createdByUserId: {
                    label: '',
                    toCmp: (createdByUserId) => createdByUserId,
                    map: (createdByUserId) => {
                        return React.createElement(UserPreview, { id: createdByUserId });
                    },
                },
                name: {
                    label: lang.apiSettings.keyName,
                    toCmp: (name) => name,
                    map: (name, key) => {
                        return (React.createElement("b", null,
                            React.createElement(CopyToClipboard, { hideIcon: true, text: key.id }, name)));
                    },
                },
                role: {
                    label: '',
                    toCmp: (role) => role,
                    map: (role) => {
                        return (React.createElement(UserType, { role: role }, lang.roles[role]));
                    },
                },
                scopes: {
                    label: 'Scopes',
                    toCmp: (scopes) => scopes.join(),
                    map: (scopes) => {
                        return (React.createElement("ul", null, scopes.map((scope) => (React.createElement("li", { key: scope }, scope)))));
                    },
                },
                createdAt: {
                    label: '',
                    toCmp: (createdAt) => createdAt,
                    map: (createdAt) => {
                        return moment(createdAt).format('DD/MM/YY H:mm:ss');
                    },
                },
            } }))) : (React.createElement(PlaceholderLoader, null)),
        modalOpen && (React.createElement(Modal, { maxWidth: "600px", onToggle: () => setModalOpen(!modalOpen), header: lang.apiSettings.newKey }, newKey ? (React.createElement("div", null,
            React.createElement("p", null, lang.apiSettings.newKeyCreatedInfo),
            React.createElement(Well, null,
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { style: {
                            wordBreak: 'break-all',
                        }, text: newKey }, newKey))),
            React.createElement("br", null),
            React.createElement(Button, { onClick: () => {
                    setNewKey('');
                    setModalOpen(false);
                } }, lang.apiSettings.closeModal))) : (React.createElement("div", null,
            React.createElement(Input, { placeholder: lang.apiSettings.keyName, value: name, onChange: (e) => {
                    setName(e.target.value);
                } }),
            React.createElement("b", null,
                React.createElement(Checkbox, { placeholder: 'Select all', checked: scopes.length > 0, checkMark: true, size: Size.Small, onChange: (e) => {
                        const checked = e.target.checked;
                        if (checked) {
                            if (meRole) {
                                setScopes(availableScopes[meRole]);
                            }
                        }
                        else {
                            setScopes([]);
                        }
                    } })),
            React.createElement("br", null),
            React.createElement("br", null),
            meRole &&
                availableScopeGroups[meRole].map((group) => (React.createElement(ScopeGroup, null, group.scopes.map((scope) => (React.createElement(ScopeCheckbox, { key: scope, onChange: (scopes) => setScopes(scopes), scope: scope, scopes: scopes })))))),
            React.createElement("br", null),
            React.createElement(Button, { block: true, disabled: !(name && name.length > 2 && scopes.length > 0), loading: createKeyMutation.isLoading, onClick: () => createKeyMutation.mutate({ name, scopes }) }, lang.apiSettings.createNewKey)))))));
};
export default APIKeys;
const ScopeCheckbox = (props) => {
    return (React.createElement("div", null,
        React.createElement(Checkbox, { placeholder: props.scope, checked: !!props.scopes.find((e) => e === props.scope), checkMark: true, size: Size.Small, onChange: (e) => {
                const checked = e.target.checked;
                props.onChange(checked
                    ? props.scopes.concat(props.scope)
                    : props.scopes.filter((_e) => _e !== props.scope));
            } })));
};
const ScopeGroup = styled.div `
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
const DocsLink = styled.a `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid ${THEME.COLOR_ACCENT};
  border-radius: 3px;
  color: ${THEME.COLOR_ACCENT};
  font-weight: 900;
  font-size: 0.85em;
  padding: 8px 14px;
  text-decoration: none;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background-color: ${THEME.COLOR_ACCENT};
    color: ${THEME.COLOR_SECONDARY};
  }
`;
//# sourceMappingURL=APIKeys.js.map